import ProjectCard from "./ProjectCard";

const projectsData = [
  {
    href: "https://donezo.live/",
    imageSrc: "./donezo.png",
    imageAlt: "Donezo Tracker",
    title: "Donezo-tracker",
    description:
      "Monitor your consistency over time. See your progress, identify patterns, and stay on track to achieve your goals.",
    techStack: "React, Typescript, Hono, Bun, Postgres, Neon",
    animationDelay: "",
  },
  {
    href: "https://github.com/Sashankps/noob-app/",
    imageSrc: "./Recipebook.jpg",
    imageAlt: "Recipe Book",
    title: "Recipe Book",
    description: "Users can choose from a wide range of recipes available...",
    techStack: "Angular, Typescript, Bootstrap",
    animationDelay: "",
  },
  {
    href: "https://github.com/Sashankps/DatingApp",
    imageSrc: "./dating-app.jpg",
    imageAlt: "Dating App",
    title: "Dating App",
    description: "A platform for people connect...",
    techStack: "Angular, Typescript, C#, EntityFramework",
    animationDelay: "custom-delay-1",
  },
  {
    href: "https://fast-pizza-ps.vercel.app/",
    imageSrc: "./fast-pizza.jpg",
    imageAlt: "Fast Pizza",
    title: "Fast Pizza",
    description:
      "Experience seamless pizza ordering with my React.js-powered website",
    techStack: "ReactJs, TailwindCSS",
    animationDelay: "custom-delay-1",
  },
  {
    href: "https://mern-auth-gqwt.onrender.com/",
    imageSrc: "./mern-auth.jpg",
    imageAlt: "Backend Auth",
    title: "Authenticator",
    description: "A MERN built authentication app",
    techStack: "ReactJs, NodeJs, ExpressJs, MongoDB",
    animationDelay: "custom-delay-4",
  },
  {
    href: "https://react-quiz-ps.netlify.app/",
    imageSrc: "./react-quiz.jpg",
    imageAlt: "React Quiz",
    title: "React-quiz",
    description: "A robust quiz app",
    techStack: "ReactJs",
    animationDelay: "custom-delay-4",
  },
  {
    href: "https://clipboard-ps.netlify.app/",
    imageSrc: "./clipboard.jpg",
    imageAlt: "Clipboard",
    title: "Clipboard",
    description: "A beatiful landing page...",
    techStack: "HTML, TailwindCSS, Javascript",
    animationDelay: "custom-delay-4",
  },
  {
    href: "https://loopstudios-ps.netlify.app/",
    imageSrc: "./loopstudios.jpg",
    imageAlt: "LoopStudios",
    title: "Loopstudios",
    description: "An eye appealing demo of VR",
    techStack: "HTML, TailwindCSS, Javascript",
    animationDelay: "custom-delay-5",
  },
  {
    href: "https://shortly-ps.netlify.app/",
    imageSrc: "./shortly.jpg",
    imageAlt: "Shortly",
    title: "Shortly",
    description: "An aesthetic landing page of the brand...",
    techStack: "HTML, TailwindCSS, Javascript",
    animationDelay: "custom-delay-6",
  },
  {
    href: "https://github.com/Sashankps/TaskManager/",
    imageSrc: "./task-manager-app-.jpg",
    imageAlt: "Task Manager",
    title: "Task Manager",
    description: "Manage your daily and upcoming tasks...",
    techStack: "Asp.Net Core MVC, C#, Sql Server, Bootstrap",
    animationDelay: "custom-delay-4",
  },
  {
    href: "https://github.com/Sashankps/TaskManager/tree/master/ExpenseTracker",
    imageSrc: "./expense-tracker-app-logo-with-expenses.jpg",
    imageAlt: "Expense Tracker",
    title: "Expense Tracker",
    description: "Track your daily expenses",
    techStack: "Asp.Net Core MVC, C#, Sql Server, Bootstrap",
    animationDelay: "custom-delay-4",
  },
  {
    href: "https://github.com/Sashankps/node-weather_website/",
    imageSrc: "./weather-app-icon-.jpg",
    imageAlt: "Weather API",
    title: "Weather API",
    description: "Retrieves real time weather forecast",
    techStack: "NodeJs, ExpressJs",
    animationDelay: "custom-delay-4",
  },
  {
    href: "https://github.com/Sashankps/redux-bank",
    imageSrc: "./redux-bank.jpg",
    imageAlt: "Virtual Bank",
    title: "Virtual Bank",
    description:
      "An app that acts as a dispatcher to manage your money in the bank",
    techStack: "ReactJS, Redux",
    animationDelay: "custom-delay-2",
  },
];

export default function Projects() {
  return (
    <section id="projects" className="relative py-24 md:py-32 border-t border-white/5">
      {/* Subtle Background Glow */}
      <div className="absolute top-1/2 right-0 -translate-y-1/2 w-[300px] h-[300px] bg-[#f15700] opacity-[0.03] blur-[120px] rounded-full pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-20 animate__animated">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Featured <span className="text-[#f15700]">Projects</span>
          </h2>
          <div className="w-20 h-1.5 bg-[#f15700] rounded-full mx-auto"></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 animate__animated">
          {projectsData.map((project, index) => (
            <ProjectCard key={index} {...project} />
          ))}
        </div>
      </div>
    </section>
  );
}
